import { UserProfile } from '@app/types/app.types';
import { createAction, props } from '@ngrx/store';

export const setProfile = createAction('[App] setProfile', props<{ profile: UserProfile }>());
